import { service } from '@ember/service';
import Component from '@glimmer/component';

import type { Service } from 'webapp-types';

import ReportsSchedulesTableComponent from 'webapp/components/reports/schedules/table';

export default class ReportsSchedulesRouteTemplate extends Component {
	@service('model-manager/report-schedules')
	declare mmReportSchedulesService: Service.ModelManager.ReportSchedules;

	get hasItems(): boolean {
		return this.mmReportSchedulesService.unsentSavedRecords.length > 0;
	}

	<template>
		{{#if this.hasItems}}
			<ReportsSchedulesTableComponent />
		{{else}}
			<p class="top-margin">No reports are scheduled to be sent out yet.</p>
		{{/if}}
	</template>
}
